import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";
import {translate} from "../../../../../components/translate/translate.jsx";

const VehiclePointsContent = ({ data }) => {

    const charts = [
        {
            id: 'quantity-by-type',
            title: 'Classificação dos veículos',
            data: data?.apply?.alarms_vehicle_classification,
            exportTitle: 'Classificação dos veículos',
            customHeader: 'Classificação',
            formatter: (value) => ReportUtils.formatText(translate(value.text))
        },
        {
            id: 'value-by-type',
            title: 'Tipos de veículos',
            data: data?.apply?.alarms_vehicle_type,
            exportTitle: 'Tipos de veículos',
            formatter: (value) => ReportUtils.formatText(value.text)
        },
        {
            id: 'value-by-gas-station',
            title: 'Alarmes por ponto de coleta',
            data: data?.apply?.pcl,
            exportTitle: 'Alarmes por ponto de coleta',
            customHeader: 'Ponto de coleta',
            formatter: (value) => ReportUtils.formatText(value.text),
            top: 10
        }
    ];

    useEffect(() => {

        charts.forEach(chart => {
            if (!chart.data) return;

            const labels = [];
            const values = [];

            chart.data.forEach(element => {
                labels.push(chart.formatter(element));
                values.push(element.qty);
            });

            GraphicUtils.barChart(chart.id, chart.top ? values.slice(0, chart.top) : values, chart.top ? labels.slice(0, chart.top) : labels, false);
            labels.length > 0 && ReportUtils.createExportableTable(labels, values, chart.exportTitle, null, chart.customHeader ? [chart.customHeader, "Quantidade"] : null);

        });

    }, [data]);

    const renderedCharts = [];

    for (let index = 0; index < charts.length; index++) {
        const currentChart = charts[index];

        renderedCharts.push(
            <React.Fragment key={currentChart.id}>

                <div className="chart-report">
                    <span className="chart-title">{currentChart.title} {currentChart.top && currentChart.data?.length >= currentChart.top ? ` (TOP ${currentChart.top})` : ''}</span>
                    <div className="mt-3" id={currentChart.id}></div>
                </div>

                { index !== charts.length - 1 &&
                    <div className="chart-divisor print:hidden"/>
                }

            </React.Fragment>
        );
    }

    return (
        <>
            {renderedCharts}
        </>
    );
};

export default VehiclePointsContent;